import { GridColumns } from "@mui/x-data-grid-premium";
import styled from "styled-components";

import Skeleton from "@mui/material/Skeleton";

// -----------------------------------------------------------------------------

export const generateLoadingColumns = (columns: GridColumns) => {
  return columns.map((value) => ({ ...value, renderCell: RenderSkeleton }));
};

export const generateLoadingRows = (count: number, id: string) => {
  const rows = [];
  for (let i = 1; i <= count; i++) {
    rows.push({ [id]: i });
  }
  return rows;
};

// -----------------------------------------------------------------------------

const RenderSkeleton = () => {
  return <SkeletonStyled />;
};

const SkeletonStyled = styled(Skeleton)`
  width: 100%;
`;
